import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/main.css';
import './assets/font-awesome/css/all.min.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import routes from './router/Routes';
import 'bootstrap/dist/css/bootstrap.css';
import { Toaster } from 'react-hot-toast';
import { UserProvider } from './context/userContext';


window.MonacoEnvironment = {
  getWorkerUrl: function (moduleId, label) {
    const proxy = URL.createObjectURL(
      new Blob(
        [
          `
            self.MonacoEnvironment = {
              baseUrl: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/'
            };
            importScripts('https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.44.0/min/vs/base/worker/workerMain.min.js');
          `,
        ],
        { type: 'text/javascript' }
      )
    );
    return proxy;
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <UserProvider>
      <RouterProvider router={routes} />
    </UserProvider>
    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        duration: 5000,
        success: {
          duration: 3000,
          theme: {
            primary: 'green',
          },
        },
      }}
    />
  </>
);
reportWebVitals();
